module.exports = __webpack_public_path__ + "img/SFJ0066.bec2fc27.jpg";